import React, { useEffect, useState } from 'react';
import { Button as ANTButton, Form, Space, notification, Switch } from 'antd';
import { Button } from '../../components/Atom/Button';
import Select from 'components/Atom/Select';
import { useQuery } from 'react-query';
import http from '../../utils/http';
const InstancePanel = ({ handleOpen, updateState, store, linkedUserData }) => {
  const [loading, setLoading] = useState(false);
  const [instanceStatus, setInstanceStatus] = useState(true);
  const [instanceData, setInstanceData] = useState(true);
  const handleInstanceChange = (e) => {
    setInstanceData(e);
  };
  const getGatewayInstance = async () => {
    const res = await http.get(`/config/gateway/${store?._id}`);
    const responseData = res?.data?.data;
    const filteredData = [];
    for (let i = 0; i < responseData?.length; i++) {
      const data = responseData[i];
      if (!linkedUserData?.assignedGatewayInstance?.some((item) => item?.instanceId === data?._id)) {
        filteredData.push({
          label: data?.name,
          value: data?._id,
        });
      }
    }
    return filteredData;
  };
  const { data, refetch, isLoading } = useQuery('gatewayInstance', getGatewayInstance, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, []);
  const onSubmit = async () => {
    setLoading(true);
    const payload = {
      instanceName: instanceData?.label,
      instanceId: instanceData?.value,
      enabled: instanceStatus,
      userAccountId: linkedUserData?.userAccountId,
      userStoreId: linkedUserData?.userStoreId?._id,
    };
    try {
      await http.post(`/linked/account/gateway/instance/${store?._id}`, payload);
      notification.success({ message: 'INSTANCE ASSIGNED SUCCESSFULLY', placement: 'bottomRight' });
      updateState();
      handleOpen();
    } catch (err) {
      notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
    }
    setLoading(false);
  };
  return (
    <Form layout='vertical' method='post' onFinish={onSubmit}>
      <Form.Item label='Gateway Instance'>
        <Select
          handleChange={handleInstanceChange}
          placeholder={'Select Gateway Instance'}
          allowClear
          showSearch
          loading={isLoading}
          getPopupContainer={(triggerNode) => triggerNode.parentElement}
          filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          optionsValue={data && data?.length > 0 ? data : null}
        />
      </Form.Item>
      <Form.Item name='instance_status' label='Instance Status'>
        <Switch checked={instanceStatus} onClick={() => setInstanceStatus(!instanceStatus)} name='instance_status' />
      </Form.Item>
      <Form.Item>
        <Space>
          <ANTButton onClick={() => handleOpen()}>Cancel</ANTButton>
          <Button type='primary' htmlType='submit' loading={loading} disabled={!instanceData}>
            {'Submit'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
export default InstancePanel;
